module.exports = __webpack_public_path__ + "assets/paypal.14e8e163.svg";